import React, { useEffect } from 'react';

export interface LogEventType {
  eventName: string;
  eventParams: Record<string, any>
}

interface HashtagPropType {
  dataType: string;
  dataName: string;
  dataRegion: string;
  dataId: string;
  onHashtagClick: (topicHref: string, dataId: string) => void;
  onLogEvent: (data: LogEventType) => void;
};

export const HashtagItem: React.FC<HashtagPropType> = props => {

  const { dataType, dataName, dataRegion, dataId, onHashtagClick, onLogEvent } = props;
  const topicPath = `/topic/${dataId}`;
  const topicHref = `${topicPath}?region=${dataRegion}`;

  const handleItemClick = (e: any) => {
    e.preventDefault();
    onHashtagClick(topicHref, dataId);
  };

  return (
    <a
      onClick={handleItemClick}
      key={`hashtag-${dataId}`}
      href={topicHref}
      className="l8editor-forum"
    >
      {dataName.replaceAll('#', '').trim() ? dataName : `#${dataName}`}
    </a>
  );
};
